"use client";
import { useState } from "react";
export function AuthView({
  onSignIn,
  setup = false,
}: {
  onSignIn: (
    role: string,
    values: { fullName: string; email: string; password: string },
  ) => Promise<string | void>;
  setup?: boolean;
}) {
  const [values, setValues] = useState({ fullName: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  return (
    <section className="auth-view" data-amazi-id={"crm/src/features/crm/auth-view.tsx:17:5"}>
      <div className="auth-card" data-amazi-id={"crm/src/features/crm/auth-view.tsx:18:7"}>
        <div className="brand-mark" data-amazi-id={"crm/src/features/crm/auth-view.tsx:19:9"}>N</div>
        <h1 data-amazi-id={"crm/src/features/crm/auth-view.tsx:20:9"}>{setup ? "Создайте администратора" : "Войти в ателье"}</h1>
        <p data-amazi-id={"crm/src/features/crm/auth-view.tsx:21:9"}>
          {setup
            ? "Это единственный первичный шаг. После создания аккаунта вы сможете пригласить команду."
            : "Управляйте заказами, примерками и командой в одном месте."}
        </p>
        {setup && (
          <label data-amazi-id={"crm/src/features/crm/auth-view.tsx:27:11"}>
            Ваше имя
            <input
              type="text"
              placeholder="Анна Крылова"
              value={values.fullName}
              onChange={(event) => setValues({ ...values, fullName: event.target.value })} data-amazi-id={"crm/src/features/crm/auth-view.tsx:29:13"}
            />
          </label>
        )}
        <label data-amazi-id={"crm/src/features/crm/auth-view.tsx:37:9"}>
          Рабочая почта
          <input
            type="email"
            placeholder="you@company.ru"
            value={values.email}
            onChange={(event) => setValues({ ...values, email: event.target.value })} data-amazi-id={"crm/src/features/crm/auth-view.tsx:39:11"}
          />
        </label>
        <label data-amazi-id={"crm/src/features/crm/auth-view.tsx:46:9"}>
          Пароль
          <input
            type="password"
            placeholder="Минимум 8 символов"
            value={values.password}
            onChange={(event) => setValues({ ...values, password: event.target.value })} data-amazi-id={"crm/src/features/crm/auth-view.tsx:48:11"}
          />
        </label>
        {error && (
          <div className="form-error" role="alert" data-amazi-id={"crm/src/features/crm/auth-view.tsx:56:11"}>
            {error}
          </div>
        )}
        <button
          className="primary-button auth-submit"
          disabled={pending}
          onClick={async () => {
            setPending(true);
            setError("");
            const message = await onSignIn("administrator", values);
            if (message) setError(message);
            setPending(false);
          }}
         data-amazi-id={"crm/src/features/crm/auth-view.tsx:60:9"}>
          {pending
            ? "Проверяем…"
            : setup
              ? "Создать администратора"
              : "Войти в рабочее пространство"}
        </button>
        <small data-amazi-id={"crm/src/features/crm/auth-view.tsx:77:9"}>
          {setup
            ? "Аккаунт будет создан только после явной отправки формы."
            : "Сессия защищена HttpOnly cookie."}
        </small>
      </div>
    </section>
  );
}
